var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5858 2.5858C15.2107 2.2107 14.702 2 14.1716 2H6C4.8954 2 4 2.8954 4 4V20C4 21.1046 4.8954 22 6 22H18C19.1046 22 20 21.1046 20 20V7.8284C20 7.2979 19.7893 6.7892 19.4142 6.4142L15.5858 2.5858ZM19 8.0001H16C14.8954 8.0001 14 7.1047 14 6.0001V3H14.1719C14.4346 3 14.6924 3.1064 14.8789 3.293L18.707 7.1211C18.8935 7.3076 19 7.5654 19 7.8281V8.0001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.97a9845a84b16ea0af5355da83b11b15.svg";
export { ForwardRef as ReactComponent };